import React from 'react';
import { RightSidebar } from "src/pages/_partials/Layout";
import { useAppSelector } from "src/store/hooks";
import Filter from "./_Filter";

const _SidebarIndex = () => {
  const countries = useAppSelector(state => state.callrecorder.availablePhoneNumbers.countries);

  return (
    <RightSidebar>
      <h6 className='v-content-label'>FILTERS</h6>
      <hr className="v-divider" />

      <Filter countries={countries} />
    </RightSidebar>
  )
}

export default _SidebarIndex;
